/** Wrapped: Auswahlseite, Story-Rahmen und die Texte, die der Client selbst auf die Slides setzt. */
export default {
  page: {
    kicker: 'Monats- und Jahresrückblick',
    title: 'Wrapped',
    periodsFailed: 'Zeiträume konnten nicht geladen werden: {error}',
    ready: 'Fertig zum Ansehen',
    running: 'Läuft noch',
    teaserTitle: 'Dein {label}',
    teaserText: { one: '{count} Einheit – in ein paar Slides erzählt.', other: '{count} Einheiten – in ein paar Slides erzählt.' },
    watch: 'Rückblick ansehen',
    all: 'Alle Rückblicke',
    periodTabs: 'Zeitraum',
    months: 'Monate',
    years: 'Jahre',
    loading: 'Lädt …',
    loadFailed: 'Dieser Rückblick ließ sich nicht laden: {error}',
    loadFailedPlain: 'Dieser Rückblick ließ sich nicht laden.',
    packing: 'Dein Rückblick wird gepackt …',
    close: 'Schließen',
    year: 'Jahr {year}',
    sessions: { one: '{count} Einheit', other: '{count} Einheiten' },
    periodAria: '{label}, {count} Einheiten',
    periodAriaRunning: '{label}, {count} Einheiten, läuft noch',
    badgeRunning: 'läuft noch',
  },
  story: {
    prev: 'Vorherige Slide',
    next: 'Nächste Slide',
    close: 'Wrapped schließen',
    slideOf: 'Slide {n} von {total}',
    progress: 'Fortschritt',
    tapClose: 'Tippen zum Schließen',
    tapNext: 'Tippen für weiter',
    saveAria: 'Slide {n} als Bild speichern',
    saving: 'Wird gespeichert …',
    saveFailed: 'Fehlgeschlagen – nochmal',
    save: 'Als Bild speichern',
    srSlide: 'Slide {n} von {total}: {label}',
  },
  slides: {
    kickerYour: 'Dein {label}',
    runningSuffix: ' · läuft noch',
    sportsOne: 'Ganz im Zeichen von {sport}.',
    sportsMostly: 'Vor allem {sport}.',
    sportsMany: '{count} Sportarten {in}.',
    sportsText: '{sport} hatte {pct} deiner Trainingszeit – {sessions}.',
    sessions: { one: '{count} Einheit', other: '{count} Einheiten' },
    kickerSports: 'Deine Sportarten · {short}',
    hours: 'Stunden',
    heartbeats: 'Rund {n} Herzschläge im Training.',
    kickerRhythm: 'Dein Rhythmus · {short}',
    favorite: 'Lieblingsstart',
    /** Anfangsbuchstaben Mo–So für das Kalenderraster. */
    weekdayInitials: 'MDMDFSS',
    streakWeeksUnit: 'Wochen am Stück aktiv.',
    activeDay: 'aktiver Tag.',
    activeDays: 'aktive Tage.',
    weekStreak: 'Deine Wochenserie',
    outIn: 'Unterwegs {in}',
    kickerStreak: 'Deine Serie · {short}',
    longestTitle: 'Deine längste Einheit',
    atTime: '{day}, {time} Uhr',
    longestLabel: 'Deine längste Einheit: {text}',
    kickerSuperlatives: 'Superlative · {short}',
    records: { one: 'Eine neue Bestleistung.', other: '{count} neue Bestleistungen.' },
    firsts: { one: 'Ein erstes Mal.', other: '{count} erste Male.' },
    before: 'vorher {prev} · {day}',
    firstTime: 'ZUM ERSTEN MAL',
    kickerRecords: 'Bestleistungen · {short}',
    races: { one: 'Ein Wettkampf.', other: '{count} Wettkämpfe.' },
    racesPb: { one: 'Eine neue Bestzeit.', other: '{count} neue Bestzeiten.' },
    kickerRaces: 'Wettkämpfe · {short}',
    raceDnf: 'abgebrochen',
    racePb: 'BESTZEIT',
    raceWatch: '~ = Zeit aus der Uhr',
    raceMore: { one: '+ ein weiterer', other: '+ {count} weitere' },
    bestNight: 'Deine beste Nacht',
    recovery: 'Deine Erholung',
    sleepHours: 'Stunden Schlaf',
    score: ' · Score {score}',
    highestHrv: 'höchste HRV',
    lowestRhr: 'niedrigster Ruhepuls',
    stepsPerDay: 'Schritte am Tag',
    avgSleep: 'Schlaf im Schnitt',
    kickerHealth: 'Erholung · {short}',
    overYears: '{short} über die Jahre',
    yearByYear: 'Jahr für Jahr',
    beforeNow: 'Vorher und jetzt',
    hoursCaps: 'STUNDEN',
    kickerCompare: 'Im Vergleich · {short}',
    routesTitle: 'Deine Wege {in}.',
    routesText: {
      one: 'Deine längste Route – ohne Karte, Start und Ziel bleiben privat.',
      other: 'Deine {count} längsten Routen – ohne Karte, Start und Ziel bleiben privat.',
    },
    routesLabel: 'Routen-Collage mit {count} Routen {in}, ohne Start und Ziel.',
    kickerRoutes: 'Routen · {short}',
    photosTitle: 'Momente {in}.',
    photosLabel: { one: '{count} Foto {in}.', other: '{count} Fotos {in}.' },
    kickerPhotos: 'Fotos · {short}',
    totalKm: '{km} km insgesamt. {eq}',
    emptyPause: '{in} war Pause.',
    emptyStarted: '{label} hat gerade erst begonnen.',
    emptyPauseText: 'Keine Aktivität aufgezeichnet – auch Pausen gehören dazu. Der nächste Rückblick wartet schon.',
    emptyStartedText: 'Noch keine Aktivität aufgezeichnet. Schau wieder rein, wenn du unterwegs warst.',
  },
};
